export default __webpack_public_path__ + "static/top-shadow-thin-cf75a1795f387dc2f87349ce1b54e2d8.png";